/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/axiosInstance.js";
import type { DeleteSession1MutationResponse, DeleteSession1PathParams, DeleteSession1400, DeleteSession1401, DeleteSession1403, DeleteSession1404, DeleteSession1409, DeleteSession1500 } from "../../types/DeleteSession1.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/axiosInstance.js";

function getDeleteSession1Url(sessionId: DeleteSession1PathParams["sessionId"]) {
  const res = { method: 'DELETE', url: `/api/research-chat/${sessionId}` as const }
  return res
}

/**
 * @summary Delete a chat session
 * {@link /api/research-chat/:sessionId}
 */
export async function deleteSession1(sessionId: DeleteSession1PathParams["sessionId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<DeleteSession1MutationResponse, ResponseErrorConfig<DeleteSession1400 | DeleteSession1401 | DeleteSession1403 | DeleteSession1404 | DeleteSession1409 | DeleteSession1500>, unknown>({ method : "DELETE", url : getDeleteSession1Url(sessionId).url.toString(), ... requestConfig })
  return res.data
}